import { createComponent } from '@carvana/merch-components';
import { CommonModuleInner } from '../styles';

export const Title = createComponent('div', {
  className:
    'max-w-[448px] text-center !font-black text-blue-6 tl-brand-s m:text-left m:tl-brand-m l:tl-brand-l'
});

export const SubTitle = createComponent('div', {
  className: 'mt-8 text-center text-grey-5 tl-body-l m:mt-16 m:text-left'
});

export const InnerWrapper = createComponent(CommonModuleInner, {
  className: 'items-start overflow-hidden'
});

export const TopSection = createComponent('div', {
  className: 'flex flex-col items-center gap-80 m:flex-row'
});

export const HeroImg = createComponent('img', {
  className:
    'h-[212px] w-[378px] rounded-t-md object-contain m:h-auto m:min-h-[360px] m:w-[616px] l:h-[493px]'
});

export const BodyStyleWrapper = createComponent('div', {
  className:
    'flex w-full max-w-[104px] flex-col items-center gap-4 rounded-md bg-grey-1 p-8 m:max-w-[190px]'
});

export const BodyStyleLabel = createComponent('span', {
  className: 'text-blue-6 tl-body-s m:tl-body-m'
});
